module.exports = __webpack_public_path__ + "static/media/um.aefba3fe.svg";